import _ from 'lodash';

export const getChildrenByTaskId = (instance, taskId) => {
  let children = [];
  let temp = [];
  const tasksIds = instance.getChildren(taskId);
  let taskItem;

  _.each(tasksIds, id => {
    taskItem = instance.getTask(id);

    children.push(taskItem);

    if (taskItem.type === instance.config.types.project) {
      temp = getChildrenByTaskId(instance, taskItem.id);

      children = children.concat(temp);
    }
  });

  return children;
};
export const getMasterLinksByTaskId = (instance, taskId) => {
  let taskLinks = [];
  let masterLinkData = {};
  const resultData = [];

  if (instance.isTaskExists(taskId)) {
    taskLinks = instance.getTask(taskId).$target;

    taskLinks.forEach(masterLinkId => {
      if (!instance.isLinkExists(masterLinkId)) {
        return false;
      }

      masterLinkData = instance.getLink(masterLinkId);

      if (!instance.isTaskExists(masterLinkData.source)) {
        return false;
      }

      resultData.push({
        linkId: masterLinkData.id,
        linkType: masterLinkData.type,
        dependencyTaskId: parseInt(masterLinkData.source, 10),
      });
    });
  }

  return resultData;
};
